/**
 * This function has the simple purpose of resolving a type issue when `key` is undeined.
 *
 * Without this function, you can't take an optional prop and get the value of a className object
 * because the prop, being optional, can have a value of undefined.
 *
 * This function simply returns '' as in the case of being undefined.
 */
export function getClassName<T extends Record<keyof T, string>>(
  classNames: T,
  key: keyof T | undefined,
): string | undefined {
  if (!key) {
    return undefined;
  } else {
    return classNames[key];
  }
}
